export default __webpack_public_path__ + "static/media/leg_tattoo_tribal.6603561f.jpg";